import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/** Current authenticated user (from the session cookie), or null if not logged in. */
export function useAuth() {
  const query = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => api.auth.me(),
    retry: false,
    staleTime: 60_000,
  });
  return { user: query.data ?? null, isLoading: query.isLoading };
}
